import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import React from "react";
import { DATA_TYPES, FONTS } from "../../constants";
import { stateType, stateTypeF } from "../../state";
import { makeHistData } from "../Common/makeHistData";
import { applyFiltersToData } from "../DataCleaning/filters";
import { getCols } from "./NumericDropdown";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(0),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(0),
    },
  })
);

export function CatDropDown({ state }: stateType) {
  const classes = useStyles();
  let nCols = getCols(state, DATA_TYPES.categorical).length;
  if (nCols === 0) {
    return <div></div>;
  }

  const handleChange = (
    event: React.ChangeEvent<{ value: unknown }>,
    state: stateTypeF
  ) => {
    const columnName = event.target.value as string;
    state.saveState.dataUpload.catHistSelected = columnName;
    calcCatHistData(state);
    state.setSaveState(state.saveState);
  };

  return (
    <div>
      <FormControl className={classes.formControl} disabled={state.isBusy}>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={state.saveState.dataUpload.catHistSelected}
          onChange={(e) => handleChange(e, state)}
          inputProps={{
            name: "numericDropdown",
            id: "age-native-simple",
          }}
          disableUnderline
          style={{ fontFamily: FONTS, color: "grey" }}
        >
          {getCols(state, DATA_TYPES.categorical).map((n) => (
            <MenuItem value={n.columnName}>{n.columnName}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

export function calcCatHistData(state: stateTypeF) {
  let col = state.saveState.dataset.getColumn(
    state.saveState.dataUpload.catHistSelected
  );
  if (col === undefined) {
    return;
  }

  let dataIngestionHistData = state.saveState.dataUpload.dataIngestionHistData;
  // Get filtered data
  let { data } = applyFiltersToData(
    state.saveState.dataset.data,
    col.columnName,
    [],
    new Set(),
    new Set()
  );

  dataIngestionHistData = makeHistData(
    data,
    col.columnType,
    new Set(),
    col.colStats.median
  );
  state.saveState.dataUpload.dataIngestionHistData = dataIngestionHistData;
  state.setSaveState(state.saveState);
}
